import { ReactNode } from 'react'

import moment from 'moment'

import { Person } from '../../../libs/user/Person'
import { Company } from '../../../libs/user/Company'
import { getSvgError } from '../../../libs/ui/icons/svg'

import People from '../People'
import { FisicaType, FisicaState, PeopleProps, getPeopleAddress } from '../PeopleSlice'

import { getProfessioni, getSesso, getStati } from '../../../libs/initialization/remoteInits'

import PersonForm from '../person/PersonForm'
import CompanyForm from '../company/CompanyForm'
import SelectContractor from './SelectContractor'

import ButtonGorup from '../../../libs/ui/buttons/ButtonGroup'
import RadioButton from '../../../libs/ui/buttons/RadioButton'

import { isNotValiDataNascita, DATE_FORMAT } from '../../../libs/validation/dateValidation'
import { 
    EMAIL_PATTERN, PHONE_NUMBER_PATTERN, NAMES_PATTERN, 
    STREET_ADDRES_PATTERN, P_IVA_PATTERN,
    isValid, isEmpty,
    isValidCityName
} from "../../../libs/validation/stringRegex"

export type ContractorType = FisicaType & {
    // solo azienda
    nomeAzienda: string | undefined
    ragioneSociale: string | undefined
    pIva: string | undefined
}

export interface ContractorState extends FisicaState {
    nomeAzienda: string | undefined
    ragioneSociale: string | undefined
    pIva: string | undefined

    nomeAziendaError?: string | undefined
    ragioneSocialeError?: string | undefined
    pIvaError?: string | undefined
}

interface ContractorProps extends PeopleProps<ContractorType> {
    isOnlyFisica?: boolean // se true permette l utilizzo di sole persone fisiche
    isOnlyGiuridica?: boolean // se true permette l utilizzo di sole persone giuridiche

    hideProfessione?: boolean // se true nasconde la selezione della professione
    
    error?: string | undefined
}

class Contractor extends People<ContractorProps, ContractorState> {

    constructor (props: any) {
        super(props)

        const contractor = this.props.people

        let tipologia = contractor?.tipoPersona

        if (this.props.isOnlyFisica) {
            tipologia = 'fisica'
        }
        if (this.props.isOnlyGiuridica) {
            tipologia = 'giuridica'
        }

        const address = getPeopleAddress (
            contractor?.street,
            contractor?.street_number,
            contractor?.zip,
            contractor?.city,
            contractor?.indirizzoResidenza_SedeLegale
        )

        let computedNatoInItalia = contractor?.natoInItalia
        if (computedNatoInItalia === undefined && contractor?.stato_nascita !== undefined) {
            computedNatoInItalia = Number(contractor?.stato_nascita) === 13
        }

        this.state = {
            profList: undefined,
            sessoList: undefined,
            statiList: undefined,

            tipoPersona: tipologia,
            
            nome: contractor?.nome,
            cognome: contractor?.cognome,
            email: contractor?.email,
            cellulare: contractor?.cellulare,

            indirizzoResidenza_SedeLegale: address,
            street: contractor?.street,
            street_number: contractor?.street_number,
            zip: contractor?.zip,
            city: contractor?.city,

            is_manual_address: (contractor?.is_manual_address !== undefined) ? contractor?.is_manual_address : false,

            sesso: contractor?.sesso,
            data_nascita: contractor?.data_nascita,

            natoInItalia: computedNatoInItalia,
            stato_nascita: contractor?.stato_nascita,
            comune_nascita: contractor?.comune_nascita,

            professione: contractor?.professione,
            
            nomeAzienda: contractor?.nomeAzienda,
            ragioneSociale: contractor?.ragioneSociale,
            pIva: contractor?.pIva,
            
            selectPeopleId: contractor?.selectPeopleId,

            tipoPersonaError: undefined,
            nomeError: undefined,
            cognomeError: undefined,
            emailError: undefined,
            cellulareError: undefined,
            nomeAziendaError: undefined,
            ragioneSocialeError: undefined,
            pIvaError: undefined,
            natoInItaliaError: undefined,
            sessoError: undefined,
            data_nascitaError: undefined,
            stato_nascitaError: undefined,
            comune_nascitaError: undefined,
            indirizzoError: undefined,
            streetError: undefined,
            street_numberError: undefined,
            zipError: undefined,
            cityError: undefined,
            professioneError: undefined,
            selectPeopleIdError: undefined,
        }

        // binding
        this.printTypeSelection = this.printTypeSelection.bind(this)
        this.updateTipoPersona = this.updateTipoPersona.bind(this)
        this.updateName = this.updateName.bind(this)
        this.updateCognome = this.updateCognome.bind(this)
        this.updateEmail = this.updateEmail.bind(this)
        this.updateCellulare = this.updateCellulare.bind(this)

        this.updateIndirizzo = this.updateIndirizzo.bind(this)
        this.setIndirizzo = this.setIndirizzo.bind(this)
        this.updateStreet = this.updateStreet.bind(this)
        this.updateStreet_number = this.updateStreet_number.bind(this)
        this.updateZip = this.updateZip.bind(this)
        this.updateCity = this.updateCity.bind(this)
        this.updateAllAddressParts = this.updateAllAddressParts.bind(this)
        this.updateIsManualAddress = this.updateIsManualAddress.bind(this)

        this.updateNatoInItalia = this.updateNatoInItalia.bind(this)
        this.updateSesso = this.updateSesso.bind(this)
        this.updateData_nascita = this.updateData_nascita.bind(this)
        this.updateStato_nascita = this.updateStato_nascita.bind(this)
        this.updateComune_nascita = this.updateComune_nascita.bind(this)
        this.updateProfessione = this.updateProfessione.bind(this)
        
        this.updateNomeAzienda = this.updateNomeAzienda.bind(this)
        this.updateRagioneSociale = this.updateRagioneSociale.bind(this)
        this.updatePiva = this.updatePiva.bind(this)
        
        this.updateSelectedPeople = this.updateSelectedPeople.bind(this)

        this.updateUserData = this.updateUserData.bind(this)
        
        this.getStateAsContractor = this.getStateAsContractor.bind(this)
        this.updateStateFromPerson = this.updateStateFromPerson.bind(this)
        this.updateStateFromCompany = this.updateStateFromCompany.bind(this)

        this.manageExpiredSession = this.manageExpiredSession.bind(this)

        this.updateProfList = this.updateProfList.bind(this)

        this.updateStatiList = this.updateStatiList.bind(this)
        this.updateSessoList = this.updateSessoList.bind(this)

        this.clearNomeError = this.clearNomeError.bind(this)
        this.clearCognomeError = this.clearCognomeError.bind(this)
        this.clearEmailError = this.clearEmailError.bind(this)
        this.clearCellulareError = this.clearCellulareError.bind(this)
        this.clearNomeAziendaError = this.clearNomeAziendaError.bind(this)
        this.clearRagioneSocialeError = this.clearRagioneSocialeError.bind(this)
        this.clearPIvaError = this.clearPIvaError.bind(this)
        this.clearNatoInItaliaError = this.clearNatoInItaliaError.bind(this)
        this.clearSessoError = this.clearSessoError.bind(this)
        this.clearData_nascitaError = this.clearData_nascitaError.bind(this)
        this.clearStato_nascitaError = this.clearStato_nascitaError.bind(this)
        this.clearComune_nascitaError = this.clearComune_nascitaError.bind(this)
        this.clearIndirizzoError = this.clearIndirizzoError.bind(this)
        this.clearStreetError = this.clearStreetError.bind(this)
        this.clearStreet_numberError = this.clearStreet_numberError.bind(this)
        this.clearZipError = this.clearZipError.bind(this)
        this.clearCityError = this.clearCityError.bind(this)
        this.clearProfessioneError = this.clearProfessioneError.bind(this)
        this.clearselectPeopleIdError = this.clearselectPeopleIdError.bind(this)

        this.setErrorsList = this.setErrorsList.bind(this)
        this.checkUpdateStateWithError = this.checkUpdateStateWithError.bind(this)
    }

    componentDidUpdate(prevProps: Readonly<ContractorProps>, prevState: Readonly<ContractorState>, snapshot?: any): void {
        if ( 
            this.checkUpdateStateWithError( this.props.error )
        ) {
            this.setErrorsList ( this.props.error )
        }
    }

    /**
     * Ogni volta che il component viene aggiornato voglio refresciare i dati dell utente
     */
    componentDidMount (): void {
        if (this.props.user !== undefined) {
            this.updateUserData ()
        }
        
        // inizializzo le professioni
        if (this.state.profList === undefined && this.props.hideProfessione !== true) {
            getProfessioni( this.updateProfList, this.manageExpiredSession )
        }
        // inizializzo i sessi
        if (this.state.sessoList === undefined) {
            getSesso( this.updateSessoList, this.manageExpiredSession )
        }
        // inizializzo gli stati
        if (this.state.statiList === undefined) {
            getStati( this.updateStatiList, this.manageExpiredSession )
        }

        // se presente nelle props forzo la tipologia della persona
        if (this.props.isOnlyFisica) {
            this.setState ({
                tipoPersona: 'fisica'
            })
        }
        if (this.props.isOnlyGiuridica) {
            this.setState ({
                tipoPersona: 'giuridica'
            })
        }
    }


    render(): ReactNode {
        const isLogged = this.props.user !== undefined

        const hasSelectionError = this.state.selectPeopleId === undefined

        const selectedId = (!isLogged || hasSelectionError) ? undefined : this.state.selectPeopleId

        this.updateSelectedPeople ( selectedId )

        return ( 
            <div className='col-12'>

                { !this.props.isOnlyFisica && !this.props.isOnlyGiuridica &&
                    this.printTypeSelection()
                }

                {(isLogged)
                    ?   <>
                            {this.state.tipoPersona !== undefined &&
                                <>
                                    <p className={hasSelectionError ? 'mt-2 is-invalid' : 'mt-2'}>
                                        <strong>
                                            {hasSelectionError && getSvgError()}
                                            Seleziona il contraente
                                        </strong>
                                    </p>
                                    { (this.state.tipoPersona === 'fisica')
                                        ?   <SelectContractor 
                                                peopleList={this.props.user?.people}
                                                profList={this.state.profList}
                                                statiList={this.state.statiList}
                                                companyList={undefined}
                                                value={selectedId}
                                                callback={this.updateStateFromPerson}
                                                updateUserCallBack={this.updateUserData}
                                                expiredSessionCallbak={this.manageExpiredSession}

                                                hideProfessione={this.props.hideProfessione}
                                            />
                                        :   <SelectContractor 
                                                peopleList={undefined}
                                                companyList={this.props.user?.companies}
                                                value={selectedId}
                                                callback={this.updateStateFromCompany}
                                                updateUserCallBack={this.updateUserData}
                                                expiredSessionCallbak={this.manageExpiredSession}
                                                
                                            />
                                    }
                                </>                        
                            }
                        </>
                    :   <>
                            {this.state.tipoPersona !== undefined &&
                                <>
                                    {(this.state.tipoPersona === 'fisica')
                                    ?   <PersonForm
                                            nome={this.state.nome}
                                            cognome={this.state.cognome}
                                            email={this.state.email}
                                            cellulare={this.state.cellulare}

                                            sesso={this.state.sesso}
                                            dataNascita={this.state.data_nascita}
                                            natoInItalia={this.state.natoInItalia}
                                            stato_nascita={this.state.stato_nascita}
                                            comune_nascita={this.state.comune_nascita}
                                            professione={this.state.professione}

                                            indirizzoResidenza={this.state.indirizzoResidenza_SedeLegale}
                                            street={this.state.street}
                                            street_number={this.state.street_number}
                                            zip={this.state.zip}
                                            city={this.state.city}

                                            is_manual_address={this.state.is_manual_address}
                                            updateManualSelectionCallBack={this.updateIsManualAddress}

                                            updateName={this.updateName}
                                            updateCognome={this.updateCognome}
                                            updateEmail={this.updateEmail}
                                            updateCellulare={this.updateCellulare}
                                            updateSesso={this.updateSesso}
                                            updateDataNascita={this.updateData_nascita}
                                            updateNatoInItalia={this.updateNatoInItalia}
                                            updateStatoNascita={this.updateStato_nascita}
                                            updateComuneNascita={this.updateComune_nascita}

                                            updateProfessione={this.updateProfessione}

                                            updateIndirizzo={this.updateIndirizzo}
                                            updateStreet={this.updateStreet}
                                            updateStreet_number={this.updateStreet_number}
                                            updateZip={this.updateZip}
                                            updateCity={this.updateCity}
                                            updateAllAddressParts={this.updateAllAddressParts}
                                            
                                            nomeError={this.state.nomeError}
                                            cognomeError={this.state.cognomeError}
                                            emailError={this.state.emailError}
                                            phoneError={this.state.cellulareError}

                                            natoInItaliaError={this.state.natoInItaliaError}
                                            sessoError={this.state.sessoError}
                                            dataNascitaError={this.state.data_nascitaError}
                                            statoError={this.state.stato_nascitaError}
                                            comuneError={this.state.comune_nascitaError}
                                            
                                            indirizzoResidenzaError={this.state.indirizzoError}
                                            streetError={this.state.streetError}
                                            street_numberError={this.state.street_numberError}
                                            zipError={this.state.zipError}
                                            cityError={this.state.cityError}

                                            profeError={this.state.professioneError}
                                            
                                            profList={this.state.profList}
                                            statiList={this.state.statiList}

                                            expiredSessionCallbak={this.props.expiredSessionCallbak}

                                            isInsert={true}
                                            hideProfessione={this.props.hideProfessione}
                                        />
                                    :   <CompanyForm
                                            nome={this.state.nome}
                                            cognome={this.state.cognome}
                                            email={this.state.email}
                                            cellulare={this.state.cellulare}

                                            nomeAzienda={this.state.nomeAzienda}
                                            ragioneSociale={this.state.ragioneSociale}
                                            pIva={this.state.pIva}
                                            indirizzoSedeLegale={this.state.indirizzoResidenza_SedeLegale}

                                            is_manual_address={this.state.is_manual_address}
                                            updateManualSelectionCallBack={this.updateIsManualAddress}

                                            indirizzoResidenza={this.state.indirizzoResidenza_SedeLegale}
                                            street={this.state.street}
                                            street_number={this.state.street_number}
                                            zip={this.state.zip}
                                            city={this.state.city}

                                            updateName={this.updateName}
                                            updateCognome={this.updateCognome}
                                            updateEmail={this.updateEmail}
                                            updateCellulare={this.updateCellulare}
                                            updateProfessione={this.updateProfessione}
                                            updateNomeAzienda={this.updateNomeAzienda}
                                            updateRagioneSociale={this.updateRagioneSociale}
                                            updatePiva={this.updatePiva}

                                            updateIndirizzo={this.updateIndirizzo}
                                            updateStreet={this.updateStreet}
                                            updateStreet_number={this.updateStreet_number}
                                            updateZip={this.updateZip}
                                            updateCity={this.updateCity}
                                            updateAllAddressParts={this.updateAllAddressParts}

                                            nomeError={this.state.nomeError}
                                            cognomeError={this.state.cognomeError}
                                            emailError={this.state.emailError}
                                            phoneError={this.state.cellulareError}

                                            nomeAziendaError={this.state.nomeAziendaError}
                                            ragioneSocialeError={this.state.ragioneSocialeError}
                                            pIvaError={this.state.pIvaError}                                            
                                            
                                            indirizzoResidenzaError={this.state.indirizzoError}
                                            streetError={this.state.streetError}
                                            street_numberError={this.state.street_numberError}
                                            zipError={this.state.zipError}
                                            cityError={this.state.cityError}
                                        />
                                    }
                                </>
                            }

                        </>
                }
            </div>
        )
    }

    // da sovrascrivere
    getStateAsContractor () {
        return {
            ...super.getStateAsContractor(),
            ...{
                nomeAzienda: this.state.nomeAzienda,
                ragioneSociale: this.state.ragioneSociale,
                pIva: this.state.pIva,
            }
        }
    }

    // privati

    // render del interfaccia
    private printTypeSelection () {
        const activeId = (this.state.tipoPersona !== undefined)
            ? 'tipo_persona_' + this.state.tipoPersona
            : undefined

        return (
            <ButtonGorup 
                id='tipo_persona'
                label='Per chi stai chiedendo un preventivo?'
                value={this.state.tipoPersona}
                callback={this.updateTipoPersona}
                error={this.state.tipoPersonaError}
            >
                <RadioButton 
                    id='tipo_persona_giuridica' name="tipoPersona" 
                    label="Sono un'azienda" 
                    value="giuridica" 
                    activeId={ activeId }
                />
                <RadioButton 
                    id='tipo_persona_fisica' name="tipoPersona" 
                    label="Sono un privato" 
                    value="fisica" 
                    activeId={ activeId }
                />
            </ButtonGorup>
        )
    }

    // setter
    private updateTipoPersona (val: 'fisica' | 'giuridica' | undefined) {
        let tipologia = val

        if (this.props.isOnlyFisica) {
            tipologia = 'fisica'
        }
        if (this.props.isOnlyGiuridica) {
            tipologia = 'giuridica'
        }

        this.setState(
            { 
                tipoPersona: tipologia,
                tipoPersonaError: undefined,
                selectPeopleId: undefined
            }, () => {
                this.props.updatePeopleCallback (
                    getEmptyContractor(tipologia)
                )
            }
        )
    }

    private updateNomeAzienda (val: string) {
        this.setState(
            {
                nomeAzienda: val,
                nomeAziendaError: undefined
            },
            () => {
                this.props.updatePeopleCallback(
                    this.getStateAsContractor()
                )
            }
        )
    }
    private updateRagioneSociale (val: string) {
        this.setState(
            {
                ragioneSociale: val,
                ragioneSocialeError: undefined
            },
            () => {
                this.props.updatePeopleCallback(
                    this.getStateAsContractor()
                )
            }
        )
    }
    private updatePiva (val: string) {
        this.setState(
            {
                pIva: val,
                pIvaError: undefined
            },
            () => {
                this.props.updatePeopleCallback(
                    this.getStateAsContractor()
                )
            }
        )
    }

    private updateStateFromPerson (selectId: string) {
        if ( this.props.user?.people ) {
            let person: Person | undefined

            (this.props.user.people).forEach ( p => {
                if (p.id === selectId) {
                    person = p
                }
            })

            const address = (
                person?.address &&
                person?.addressNumber &&
                person?.postalCodeOfResidence &&
                person?.cityOfResidence
            )   
                ? person?.address + ', ' + person?.addressNumber + ', ' + person?.postalCodeOfResidence + ' ' + person?.cityOfResidence?.id + ', ITALIA'
                : person?.address

            if (person) {
                this.setState({
                    tipoPersona: 'fisica',
                    nome: person.name,
                    cognome: person.surname,

                    email: person.email ?? this.props.user.email,
                    cellulare: person.phone ?? this.props.user.phone,
                    
                    sesso: this.getValueForGender( person.gender ),
                    data_nascita: moment(person.dateOfBirth).format(DATE_FORMAT),
                    
                    natoInItalia: (person?.bornInItaly || Number(person?.countryOfBirth?.id) === 13),
                    stato_nascita: this.getValueForCountry( person ),
                    comune_nascita: person.cityOfBirth?.id,
                    indirizzoResidenza_SedeLegale: address,

                    professione: person.profession,

                    nomeAzienda: undefined,
                    ragioneSociale: undefined,
                    pIva: undefined,
                    
                    selectPeopleId: selectId
                },
                () => {
                    this.props.updatePeopleCallback(
                        this.getStateAsContractor()
                    )
                }
            )
            }
        }
    }
    private updateStateFromCompany (selectId: string) {
        if ( this.props.user?.companies ) {
            let company: Company | undefined

            (this.props.user.companies).forEach ( p => {
                if (p.id === selectId) {
                    company = p
                }
            })

            if (company) {
                this.setState({
                    tipoPersona: 'giuridica',
                    nome: company.referent_first_name,
                    cognome: company.referent_last_name,
                    email: company.referent_email ?? this.props.user.email,
                    cellulare: company.referent_phone ?? this.props.user.phone,
                    sesso: undefined,
                    data_nascita: undefined,
                    stato_nascita: undefined,
                    comune_nascita: undefined,
                    professione: undefined,
                    nomeAzienda: company.name,
                    ragioneSociale: company.legal_name,
                    pIva: company.vat,
                    indirizzoResidenza_SedeLegale: company.registered_office_address,
                    selectPeopleId: selectId
                },
                () => {
                    this.props.updatePeopleCallback(
                        this.getStateAsContractor()
                    )
                }
            )
            }
        }
    }

    // errori
    private clearNomeAziendaError () {
        this.setState({
            nomeAziendaError: undefined
        })
    }
    private clearRagioneSocialeError () {
        this.setState({
            ragioneSocialeError: undefined
        })
    }
    private clearPIvaError () {
        this.setState({
            pIvaError: undefined
        })
    }

    private setErrorsList (error: string | undefined) {
        let nextErrorList : any = {
            tipoPersonaError: undefined,
            nomeError: undefined,
            cognomeError: undefined,
            emailError: undefined,
            cellulareError: undefined,
            nomeAziendaError: undefined,
            ragioneSocialeError: undefined,
            pIvaError: undefined,
            natoInItaliaError: undefined,
            sessoError: undefined,
            data_nascitaError: undefined,
            stato_nascitaError: undefined,
            comune_nascitaError: undefined,
            indirizzoError: undefined,
            streetError: undefined,
            street_numberError: undefined,
            zipError: undefined,
            cityError: undefined,
            professioneError: undefined,
            selectPeopleIdError: undefined,
        }

        const invalidString = 'Valore non valido'

        let update = false

        if (error === 'CONTRACTOR_TIPO_PERSONA' && this.state.tipoPersonaError !== invalidString) {
            nextErrorList.tipoPersonaError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_SELECTION' && this.state.selectPeopleIdError !== invalidString) {
            nextErrorList.selectPeopleIdError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_NAME' && this.state.nomeError !== invalidString) {
            nextErrorList.nomeError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_SURNAME' && this.state.cognomeError !== invalidString) {
            nextErrorList.cognomeError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_GENDER' && this.state.sessoError !== invalidString) {
            nextErrorList.sessoError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_BIRTHDATE' && this.state.data_nascitaError !== invalidString) {
            nextErrorList.data_nascitaError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_BORN_IN_ITALY' && this.state.natoInItaliaError !== invalidString) {
            nextErrorList.natoInItaliaError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_COUNTRY_OF_BIRTH' && this.state.stato_nascitaError !== invalidString) {
            nextErrorList.stato_nascitaError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_CITY_OF_BIRTH' && this.state.comune_nascitaError !== invalidString) {
            nextErrorList.comune_nascitaError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_COMPANY_NAME' && this.state.nomeAziendaError !== invalidString) {
            nextErrorList.nomeAziendaError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_COMPANY_LEGAL_NAME' && this.state.ragioneSocialeError !== invalidString) {
            nextErrorList.ragioneSocialeError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_COMPANY_VAT' && this.state.pIvaError !== invalidString) {
            nextErrorList.pIvaError = invalidString
            update = true
        }
        else if ((error === 'CONTRACTOR_ADDRESS' || error === 'CONTRACTOR_ADDRESS_NOT_FOUND') && this.state.indirizzoError !== invalidString) {
            nextErrorList.indirizzoError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_STREET' && this.state.streetError !== invalidString) {
            nextErrorList.streetError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_STREET_NUMBER' && this.state.street_numberError !== invalidString) {
            nextErrorList.street_numberError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_CITY' && this.state.zipError !== invalidString) {
            nextErrorList.zipError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_ZIP' && this.state.cityError !== invalidString) {
            nextErrorList.cityError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_EMAIL' && this.state.emailError !== invalidString) {
            nextErrorList.emailError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_PHONE' && this.state.cellulareError !== invalidString) {
            nextErrorList.cellulareError = invalidString
            update = true
        }
        else if (error === 'CONTRACTOR_PROFESSION' && this.state.professioneError !== invalidString) {
            nextErrorList.professioneError = invalidString
        }

        if (update) {
            this.setState ( nextErrorList )
        }
    }

    private checkUpdateStateWithError (error: string | undefined) {
        return (error === 'CONTRACTOR_TIPO_PERSONA' && this.state.tipoPersonaError === undefined  && isEmpty(this.state.tipoPersona)) ||
                (error === 'CONTRACTOR_SELECTION' && this.state.selectPeopleIdError === undefined  && isEmpty(this.state.selectPeopleId)) ||
                (error === 'CONTRACTOR_NAME' && this.state.nomeError === undefined  && isEmpty(this.state.nome)) ||
                (error === 'CONTRACTOR_SURNAME' && this.state.cognomeError === undefined  && isEmpty(this.state.cognome)) ||
                (error === 'CONTRACTOR_GENDER' && this.state.sessoError === undefined  && this.state.sesso === undefined) ||
                (error === 'CONTRACTOR_BIRTHDATE' && this.state.data_nascitaError === undefined  && isEmpty(this.state.data_nascita)) ||
                (error === 'CONTRACTOR_BORN_IN_ITALY' && this.state.natoInItaliaError === undefined  && this.state.natoInItalia === undefined) ||
                (error === 'CONTRACTOR_COUNTRY_OF_BIRTH' && this.state.stato_nascitaError === undefined  && this.state.stato_nascita === undefined) ||
                (error === 'CONTRACTOR_CITY_OF_BIRTH' && this.state.comune_nascitaError === undefined  && isEmpty(this.state.comune_nascita)) ||
                (error === 'CONTRACTOR_COMPANY_NAME' && this.state.nomeAziendaError === undefined  && isEmpty(this.state.nomeAzienda)) ||
                (error === 'CONTRACTOR_COMPANY_LEGAL_NAME' && this.state.ragioneSocialeError === undefined  && isEmpty(this.state.ragioneSociale)) ||
                (error === 'CONTRACTOR_COMPANY_VAT' && this.state.pIvaError === undefined  && isEmpty(this.state.pIva)) ||
                (
                    (error === 'CONTRACTOR_ADDRESS' || error === 'CONTRACTOR_ADDRESS_NOT_FOUND')
                    // &&  this.state.indirizzoError === undefined  && isEmpty(this.state.indirizzoResidenza_SedeLegale)
                ) ||
                (error === 'CONTRACTOR_STREET' && this.state.streetError === undefined  && isEmpty(this.state.street)) ||
                (error === 'CONTRACTOR_STREET_NUMBER' && this.state.street_numberError === undefined  && isEmpty(this.state.street_number)) ||
                (error === 'CONTRACTOR_CITY' && this.state.zipError === undefined  && isEmpty(this.state.zip)) ||
                (error === 'CONTRACTOR_ZIP' && this.state.cityError === undefined  && isEmpty(this.state.city)) ||
                (error === 'CONTRACTOR_EMAIL' && this.state.emailError === undefined  && isEmpty(this.state.email)) ||
                (error === 'CONTRACTOR_PHONE' && this.state.cellulareError === undefined  && isEmpty(this.state.cellulare)) ||
                (error === 'CONTRACTOR_PROFESSION' && this.state.professioneError === undefined  && this.state.professione === undefined)
    }
}

export default Contractor


export function getEmptyContractor ( tipoPersona?: 'fisica' | 'giuridica' | undefined ) : ContractorState {
    return {
        tipoPersona: tipoPersona ?? undefined,

        nome: undefined,
        cognome: undefined,
        email: undefined,
        cellulare: undefined,

        indirizzoResidenza_SedeLegale: undefined,
        street: undefined,
        street_number: undefined,
        zip: undefined,
        city: undefined,

        is_manual_address: false,

        natoInItalia: undefined,
        sesso: undefined,
        data_nascita: undefined,
        stato_nascita: undefined,
        comune_nascita: undefined,
        professione: undefined,
        
        nomeAzienda: undefined,
        ragioneSociale: undefined,
        pIva: undefined,

        sessoList: undefined,
        statiList: undefined,
        profList: undefined,

        selectPeopleId: undefined,
    }
}

export function isValidContractor (c: ContractorType, ignoreProfession?: boolean | undefined) {

    if (c.selectPeopleId !== undefined) {
        return true
    }

    if (c.tipoPersona === 'fisica') {
        return (
            isValid (c.nome, NAMES_PATTERN) && 
            isValid (c.cognome, NAMES_PATTERN) && 
            isValid (c.cellulare, PHONE_NUMBER_PATTERN) &&
            isValid (c.email, EMAIL_PATTERN) &&
            // sesso
            c.sesso !== undefined &&
            // stato nascita
            c.stato_nascita !== undefined &&
            // comune nascita
            (
                (
                    c.stato_nascita === 13 && // italia
                    isValidCityName(c.comune_nascita)
                ) ||
                (
                    c.stato_nascita !== 13 && // stato estero
                    c.comune_nascita === undefined
                )
            ) &&
            !isNotValiDataNascita(c.data_nascita) &&
            (ignoreProfession === true || !isEmpty(c.professione)) &&
            isValid (c.indirizzoResidenza_SedeLegale, STREET_ADDRES_PATTERN)
        )
    } else {
        return (
            isValid (c.nome, NAMES_PATTERN) && 
            isValid (c.cognome, NAMES_PATTERN) && 
            isValid (c.cellulare, PHONE_NUMBER_PATTERN) &&
            isValid (c.email, EMAIL_PATTERN) &&
            !isEmpty (c.nomeAzienda ) &&
            !isEmpty (c.ragioneSociale ) &&
            isValid (c.pIva, P_IVA_PATTERN) &&
            isValid (c.indirizzoResidenza_SedeLegale, STREET_ADDRES_PATTERN)
        )
    }
    
}

export function getContractorError (contractor: ContractorType, isLogged: boolean, ignoreProfession?: boolean | undefined) {
    
    if (contractor.tipoPersona === undefined) {
        return 'CONTRACTOR_TIPO_PERSONA'
    }
    else if (isLogged && contractor.selectPeopleId === undefined)  {
        return 'CONTRACTOR_SELECTION'
    } 
    else {
        if (
            contractor.tipoPersona === 'fisica' &&
            isEmpty(contractor.nome)
        ) {
            return 'CONTRACTOR_NAME'
        }
        else if (
            contractor.tipoPersona === 'fisica' &&
            isEmpty(contractor.cognome)
        ) {
            return 'CONTRACTOR_SURNAME'
        }

        else if (
            contractor.tipoPersona === 'fisica' &&
            isEmpty(contractor.sesso?.toString())
        ) {
            return 'CONTRACTOR_GENDER'
        }
        else if (
            contractor.tipoPersona === 'fisica' &&
            (isEmpty(contractor.data_nascita) || isNotValiDataNascita(contractor.data_nascita))
        ) {
            return 'CONTRACTOR_BIRTHDATE'
        }
        else if (
            contractor.tipoPersona === 'fisica' &&
            contractor.natoInItalia === undefined
        ) {
            return 'CONTRACTOR_BORN_IN_ITALY'
        }
        else if (
            contractor.tipoPersona === 'fisica' &&
            isEmpty(contractor.stato_nascita?.toString())
        ) {
            return 'CONTRACTOR_COUNTRY_OF_BIRTH'
        }
        else if (
            contractor.tipoPersona === 'fisica' &&
            contractor.natoInItalia === true && !isValidCityName(contractor.comune_nascita)
        ) {
            return 'CONTRACTOR_CITY_OF_BIRTH'
        }

        else if (
            contractor.tipoPersona !== 'fisica' &&
            isEmpty(contractor.nomeAzienda)
        ) {
            return 'CONTRACTOR_COMPANY_NAME'
        }
        else if (
            contractor.tipoPersona !== 'fisica' &&
            isEmpty(contractor.pIva)
        ) {
            return 'CONTRACTOR_COMPANY_VAT'
        }
        else if (
            contractor.tipoPersona !== 'fisica' &&
            isEmpty(contractor.ragioneSociale)
        ) {
            return 'CONTRACTOR_COMPANY_LEGAL_NAME'
        }
        // la form è organizzata spostando campi a manca e a destra ... serve una doppia validazione in base al tipo persona
        else if (
            contractor.tipoPersona !== 'fisica' &&
            !isValid (contractor.indirizzoResidenza_SedeLegale, STREET_ADDRES_PATTERN)
        ) {
            return 'CONTRACTOR_ADDRESS'
        }
        // valido solo per le nuove inserzioni.. se loggato consta solo indirizzoResidenza_sedeLegale
        else if (
            !isLogged &&
            contractor.tipoPersona !== 'fisica' &&
            isEmpty(contractor.city)
        ) {
            return 'CONTRACTOR_CITY'
        }
        else if (
            !isLogged &&
            contractor.tipoPersona !== 'fisica' &&
            isEmpty(contractor.zip)
        ) {
            return 'CONTRACTOR_ZIP'
        }
        else if (
            !isLogged &&
            contractor.tipoPersona !== 'fisica' &&
            isEmpty(contractor.street)
        ) {
            return 'CONTRACTOR_STREET'
        }
        else if (
            !isLogged &&
            contractor.tipoPersona !== 'fisica' &&
            isEmpty(contractor.street_number)
        ) {
            return 'CONTRACTOR_STREET_NUMBER'
        }        

        else if (
            contractor.tipoPersona !== 'fisica' &&
            isEmpty(contractor.nome)
        ) {
            return 'CONTRACTOR_NAME'
        }
        else if (
            contractor.tipoPersona !== 'fisica' &&
            isEmpty(contractor.cognome)
        ) {
            return 'CONTRACTOR_SURNAME'
        }

        else if (
            contractor.tipoPersona === 'fisica' &&
            !isValid (contractor.indirizzoResidenza_SedeLegale, STREET_ADDRES_PATTERN)
        ) {
            return 'CONTRACTOR_ADDRESS'
        }
        else if (
            !isLogged &&
            contractor.tipoPersona === 'fisica' &&
            isEmpty(contractor.city)
        ) {
            return 'CONTRACTOR_CITY'
        }
        else if (
            !isLogged &&
            contractor.tipoPersona === 'fisica' &&
            isEmpty(contractor.zip)
        ) {
            return 'CONTRACTOR_ZIP'
        }
        else if (
            !isLogged &&
            contractor.tipoPersona === 'fisica' &&
            isEmpty(contractor.street)
        ) {
            return 'CONTRACTOR_STREET'
        }
        else if (
            !isLogged &&
            contractor.tipoPersona === 'fisica' &&
            isEmpty(contractor.street_number)
        ) {
            return 'CONTRACTOR_STREET_NUMBER'
        }
        

        else if (isEmpty(contractor.email)) {
            return 'CONTRACTOR_EMAIL'
        }
        else if (isEmpty(contractor.cellulare)) {
            return 'CONTRACTOR_PHONE'
        }

        else if (
            contractor.tipoPersona === 'fisica' &&
            ignoreProfession !== true &&
            isEmpty(contractor.professione)
        ) {
            return 'CONTRACTOR_PROFESSION'
        }
        
    }

    return undefined
}

export function getContractorForSubmit (contractor: ContractorType) {
    const address = getPeopleAddress(
        contractor.street,
        contractor.street_number,
        contractor.zip,
        contractor.city,
        contractor.indirizzoResidenza_SedeLegale
    )

    let cntr = {
        nome: contractor.nome,
        cognome: contractor.cognome,
        email: contractor.email,
        telefono: contractor.cellulare,

        indirizzoResidenza_SedeLegale: address,
        // via: contractor.street,
        // civico: contractor.street_number,
        // cap: contractor.zip,
        // comuneNascita: contractor.city
    }

    if (contractor.tipoPersona === 'fisica') {
        cntr = {
            ...cntr,
            ...{
                    sesso: contractor.sesso,
                    dataNascita: contractor.data_nascita,
                    nazionalita: contractor.stato_nascita,
                    comuneNascita: contractor.comune_nascita,
                    professione: contractor.professione,
                }
        }
    }

    if (contractor.tipoPersona === 'giuridica') {
        cntr = {
            ...cntr,
            ...{
                    nomeAzienda: contractor.nomeAzienda,
                    pIva: contractor.pIva,
                    ragionSociale: contractor.ragioneSociale
                }
        }
    }

    return cntr
}
